import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { UserPlus, Check, Eye, EyeOff } from 'lucide-react';
import { LOGO_RAIZES_WHITE } from '../lib/branding';
import { toast } from 'sonner';
import DateInput from '../components/DateInput';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CadastroVoluntarioPublico = () => {
  const navigate = useNavigate();
  const [areas, setAreas] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    nome: '',
    celular: '',
    email: '',
    data_nascimento: '',
    areas: [],
    password: '',
  });

  useEffect(() => {
    axios.get(`${API}/volunteers/areas`).then(r => setAreas(r.data)).catch(() => {});
  }, []);

  const toggleArea = (val) => {
    setForm(p => ({
      ...p,
      areas: p.areas.includes(val) ? p.areas.filter(a => a !== val) : [...p.areas, val]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.celular || !form.email || !form.data_nascimento || !form.password) {
      toast.error('Preencha todos os campos obrigatorios');
      return;
    }
    if (form.password.length < 4) {
      toast.error('Senha deve ter no minimo 4 caracteres');
      return;
    }
    try {
      await axios.post(`${API}/volunteers/self-register`, form);
      setSuccess(true);
      toast.success('Cadastro realizado!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao cadastrar');
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-[#1A4D2E] flex flex-col items-center justify-center px-6">
        <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl" data-testid="success-card">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
            <Check className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="font-nunito font-bold text-2xl text-[#1A4D2E] mb-2">Cadastro Realizado!</h2>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
            <p className="text-amber-800 text-sm font-semibold mb-1">Aguardando aprovacao</p>
            <p className="text-amber-700 text-xs">Seu cadastro sera analisado e so sera confirmado com o OK do administrador do ministerio.</p>
          </div>
          <button
            onClick={() => navigate('/login')}
            data-testid="go-login-btn"
            className="w-full bg-[#1A4D2E] text-white py-3 rounded-xl font-semibold hover:bg-[#145A32] transition-colors"
          >
            Ir para Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1A4D2E]">
      <div className="px-6 pt-10 pb-6 text-center">
        <img src={LOGO_RAIZES_WHITE} alt="Ministério Raízes" className="h-20 mx-auto mb-4 drop-shadow-xl" />
        <h1 className="font-nunito font-bold text-2xl text-white mb-1">Cadastro de Voluntario</h1>
        <p className="text-white/70 text-sm">Preencha seus dados para se cadastrar</p>
      </div>

      <div className="px-4 pb-10">
        <form onSubmit={handleSubmit} autoComplete="off" className="bg-white rounded-2xl p-6 max-w-md mx-auto shadow-2xl space-y-4" data-testid="register-form">
          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Nome Completo *</label>
            <input
              value={form.nome}
              onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
              autoComplete="new-password"
              className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm focus:border-[#1A4D2E] focus:ring-1 focus:ring-[#1A4D2E] outline-none"
              placeholder="Seu nome completo"
              data-testid="input-nome"
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Celular *</label>
            <input
              value={form.celular}
              onChange={e => setForm(p => ({ ...p, celular: e.target.value }))}
              autoComplete="new-password"
              className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm focus:border-[#1A4D2E] focus:ring-1 focus:ring-[#1A4D2E] outline-none"
              placeholder="(11) 99999-9999"
              data-testid="input-celular"
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">E-mail *</label>
            <input
              type="email"
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              autoComplete="new-password"
              className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm focus:border-[#1A4D2E] focus:ring-1 focus:ring-[#1A4D2E] outline-none"
              placeholder="seu@email.com"
              data-testid="input-email"
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Data de Nascimento *</label>
            <DateInput
              name="data_nascimento"
              value={form.data_nascimento}
              onChange={e => setForm(p => ({ ...p, data_nascimento: e.target.value }))}
              className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm focus:border-[#1A4D2E] focus:ring-1 focus:ring-[#1A4D2E] outline-none"
              data-testid="input-nascimento"
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Senha de Acesso *</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                autoComplete="new-password"
                className="w-full rounded-xl border border-gray-200 px-4 py-2.5 pr-10 text-sm focus:border-[#1A4D2E] focus:ring-1 focus:ring-[#1A4D2E] outline-none"
                placeholder="Minimo 4 caracteres"
                data-testid="input-password"
              />
              <button type="button" onClick={() => setShowPassword(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 mb-2 block">Areas de Interesse</label>
            <div className="grid grid-cols-2 gap-2">
              {areas.map(a => {
                const selected = form.areas.includes(a.value);
                return (
                  <button
                    type="button"
                    key={a.value}
                    onClick={() => toggleArea(a.value)}
                    data-testid={`area-${a.value}`}
                    className={`text-xs px-3 py-2 rounded-lg border transition-all text-left ${
                      selected
                        ? 'bg-[#1A4D2E] text-white border-[#1A4D2E]'
                        : 'bg-white text-gray-600 border-gray-200 hover:border-[#1A4D2E]'
                    }`}
                  >
                    {a.label}
                  </button>
                );
              })}
            </div>
          </div>

          <button
            type="submit"
            data-testid="submit-btn"
            className="w-full bg-[#1A4D2E] text-white py-3 rounded-xl font-semibold hover:bg-[#145A32] transition-colors flex items-center justify-center gap-2 mt-4"
          >
            <UserPlus className="w-5 h-5" /> Cadastrar
          </button>
        </form>
      </div>
    </div>
  );
};

export default CadastroVoluntarioPublico;
